import * as React from 'react';

import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility'

const TimeoutModal = ({ closeModal, finishLesson }) => {
  const { modalRef, } = useModalAccessibility(closeModal)

  return (
    <div className="timeout-modal-container">
      <div className="timeout-modal-background" onClick={closeModal} />
      <div
        aria-labelledby="timeout-modal-title"
        aria-modal="true"
        className="timeout-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h2 id="timeout-modal-title">Are you still using this lesson with your students?</h2>
        <p>If you are no longer collaborating on this lesson with your students, you can mark it as <em>complete</em>. Once your lesson is marked complete, your student answers will be saved in the <strong>Activity Analysis</strong> report. If you want to resume this lesson at a later time, you can close the tab and launch it later.</p>
        <div className="timeout-modal-buttons">
          <button className="quill-button outlined medium green focus-on-light" onClick={finishLesson} type="button">No, mark lesson as complete</button>
          <button className="quill-button contained medium green focus-on-light" onClick={closeModal} type="button">Yes, resume lesson</button>
        </div>
      </div>
    </div>
  )
}

export default TimeoutModal
